import template from './acris-faq-keyword-modal-form.html.twig';

const { Mixin } = Shopware;
const { Component } = Shopware;

Component.register('acris-faq-keyword-modal-form', {
    template,

    inject: ['repositoryFactory'],

    mixins: [
        Mixin.getByName('notification'),
        Mixin.getByName('placeholder')
    ],

    props: {
        keyword: {
            type: Object,
            required: true
        }
    },

    computed: {
        optionsKeywordMatchType() {
            return [
                { value: "strict", label: this.$tc('acris-faq.detail.fieldOptionLabelMatchingTypeStrict') },
                { value: "regex", label: this.$tc('acris-faq.detail.fieldOptionLabelMatchingTypeRegex') },
            ];
        }
    },

    methods: {
        changeMatchingType() {
            this.keyword.name = '';
        },
    }
});
